import { useState } from "react";

export function useAccessoryLists() {
  // ── Racks ──
  // Row add/remove/edit and active-tab tracking now live in <DynamicTabsForm>
  // (components/DynamicTabsForm.js), which owns that logic generically for
  // every accessory type. This hook only keeps the state DynamicTabsForm
  // doesn't: whether the section is enabled, and per-field validation errors.
  const [rackEnabled, setRackEnabled] = useState(false);
  const [rackLists, setRackLists] = useState([]);
  const [activeRackTab, setActiveRackTab] = useState(0);
  const [rackFieldErrors, setRackFieldErrors] = useState({});

  // ── Baskets ──
  const [basketEnabled, setBasketEnabled] = useState(false);
  const [basketLists, setBasketLists] = useState([]);
  const [activeBasketTab, setActiveBasketTab] = useState(0);
  const [basketFieldErrors, setBasketFieldErrors] = useState({});

  // ── Hooks ──
  const [hooksEnabled, setHooksEnabled] = useState(false);
  const [hooksLists, setHooksLists] = useState([]);
  const [activeHooksTab, setActiveHooksTab] = useState(0);
  const [hookFieldErrors, setHookFieldErrors] = useState({});

  // ── Hampers ──
  const [hamperEnabled, setHamperEnabled] = useState(false);
  const [hamperLists, setHamperLists] = useState([]);
  const [activeHamperTab, setActiveHamperTab] = useState(0);
  const [hamperFieldErrors, setHamperFieldErrors] = useState({});

  return {
    rackEnabled, setRackEnabled,
    rackLists, setRackLists,
    activeRackTab, setActiveRackTab,
    rackFieldErrors, setRackFieldErrors,
    basketEnabled, setBasketEnabled,
    basketLists, setBasketLists,
    activeBasketTab, setActiveBasketTab,
    basketFieldErrors, setBasketFieldErrors,
    hooksEnabled, setHooksEnabled,
    hooksLists, setHooksLists,
    activeHooksTab, setActiveHooksTab,
    hookFieldErrors, setHookFieldErrors,
    hamperEnabled, setHamperEnabled,
    hamperLists, setHamperLists,
    activeHamperTab, setActiveHamperTab,
    hamperFieldErrors, setHamperFieldErrors,
  };
}
